// extracted by mini-css-extract-plugin
module.exports = {"networkBlock":"NetworkCard_networkBlock__xk6zY","networkBlock_img":"NetworkCard_networkBlock_img__klkUn","networkBlock_text":"NetworkCard_networkBlock_text__vP1Ip"};